import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingContact from "@/components/FloatingContact";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Courses from "@/pages/Courses";
import CourseDetails from "@/pages/CourseDetails";
import CoursePlayer from "@/pages/CoursePlayer";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import Demo from "@/pages/Demo";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Career from "@/pages/Career";
import StudyAbroad from "@/pages/StudyAbroad";
import Legal from "@/pages/Legal";
import Testimonials from "@/pages/Testimonials";
import Admin from "@/pages/Admin";
import Instructor from "@/pages/Instructor";

function AppRouter() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/:slug" element={<CourseDetails />} />
        <Route path="/learn/:slug" element={<ProtectedRoute><CoursePlayer /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute role="admin"><Admin /></ProtectedRoute>} />
        <Route path="/instructor" element={<ProtectedRoute><Instructor /></ProtectedRoute>} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Login />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/career" element={<Career />} />
        <Route path="/study-abroad" element={<StudyAbroad />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/privacy" element={<Legal kind="Privacy" />} />
        <Route path="/terms" element={<Legal kind="Terms" />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      <Footer />
      <FloatingContact />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <SmoothScroll>
            <AppRouter />
          </SmoothScroll>
        </BrowserRouter>
      </AuthProvider>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
